import { render, staticRenderFns } from "./ToolOverlay.vue?vue&type=template&id=0d8b97ec&scoped=true"
import script from "./ToolOverlay.vue?vue&type=script&lang=ts"
export * from "./ToolOverlay.vue?vue&type=script&lang=ts"
import style0 from "./ToolOverlay.vue?vue&type=style&index=0&id=0d8b97ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8b97ec",
  null
  
)

export default component.exports